import styles from "./index.module.scss";
import {ReactComponent as CloseBtn} from "../Images/closeBtn.svg";

function RankPopup({rankData, rankList, dismiss}) {
  const handleClose = () => {
    dismiss();
  };

  return (
    <>
      <div className={styles.container}>
        <CloseBtn className={styles.close_btn} onClick={handleClose} />
        <div className={styles.contents_wrapper}>
          <div className={styles.title}>LEADERBOARD</div>
          <div className={styles.list_container}>
            <div className={styles.item_my_wrapper}>
              <div className={styles.item_zone}>RANK</div>
              <div className={styles.item_school}>SEKOLAH</div>
              <div className={styles.item_state}>SKOR</div>
            </div>
            <div className={styles.item_border_wrapper}>
              <div className={styles.item_title_wrapper}>
                <div className={styles.item_zone}>{rankData.ranking}</div>
                <div className={styles.item_school}>{rankData.school}</div>
                <div className={styles.item_state}>{rankData.totalPoint}</div>
              </div>
              <div className={styles.scroll_wrapper}>
                {rankList &&
                  rankList.map(item => {
                    return <SchoolListItem key={item.school} rank={item.ranking} score={item.totalPoint} school={item.school} />;
                  })}
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
}

const SchoolListItem = ({rank, score, school}) => {
  return (
    <>
      <div className={styles.item_wrapper}>
        <div className={styles.item_zone}>{rank}</div>
        <div className={styles.item_school}>{school}</div>
        <div className={styles.item_state}>{score}</div>
      </div>
    </>
  );
};

export default RankPopup;
